import { render } from "./TrangChu.vue?vue&type=template&id=4961de40&scoped=true"
import script from "./TrangChu.vue?vue&type=script&lang=js"
export * from "./TrangChu.vue?vue&type=script&lang=js"

import "./TrangChu.vue?vue&type=style&index=0&id=4961de40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4961de40"]])

export default __exports__